// src/pages/HomePage.js
import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import InteractiveDemo from "../components/InteractiveDemo";
import PricingSection from "../components/PricingSection";
import CTA from "../components/CTA";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import {VerifyEmail} from "./../api/auth/auth"
function HomePage() {
  const sendVerifEmail = async(token )=>{
    await VerifyEmail({token : token});
  }
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token){
      sendVerifEmail(token);
    }
    const handleNavClick = (e, target) => {
      e.preventDefault();

      const cleanTarget = target.startsWith('/') ? target.slice(1) : target; // Remove leading slash
      const element = document.querySelector(cleanTarget);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };

    const navLinks = document.querySelectorAll('nav a');
    navLinks.forEach(link => {
      link.addEventListener('click', (e) => handleNavClick(e, link.getAttribute('href')));
    });

    return () => {
      navLinks.forEach(link => {
        link.removeEventListener('click', handleNavClick);
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <PricingSection />
      <CTA />
      <Contact />
      <Footer />
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(50px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideIn {
          from { opacity: 0; transform: translateX(-100px); }
          to { opacity: 1; transform: translateX(0); }
        }
        .animate-fadeIn { animation: fadeIn 1s ease-out; }
        .animate-fadeInUp { animation: fadeInUp 1s ease-out; }
        .animate-slideUp { animation: slideUp 1s ease-out; }
        .animate-slideIn { animation: slideIn 1s ease-out; }
        .delay-100 { animation-delay: 0.1s; }
        .delay-200 { animation-delay: 0.2s; }
        .delay-300 { animation-delay: 0.3s; }
      `}</style>
    </div>
  );
}

export default HomePage;
